import { Button, message, Modal, Select } from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import getNavbarTitle from "./getNavbarTitle";
import NavbarIconButton from "../buttons/NavbarIconButton";
import NavbarAdminSearch from "./NavbarAdminSearch";
import ProfilePopup from "../components/ProfilePopup";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { setPharmacyDetails } from "../Store/slices/User";
import NotificationsTab from "../components/NotificationsTab";
import useResponsive from "../hooks/useResponsive";

const Navbar = () => {
  // Use our custom hook for responsive state and actions
  const {
    isSidebarCollapsed,
    isResponsiveMode,
    toggleSidebar
  } = useResponsive();

  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pharmacyList, setPharmacyList] = useState([]);
  const user = useSelector((state) => state.user.user);
  const pharmacyDetails = useSelector((state) => state.user.pharmacyDetails);
  const disabled = user.roleDetails.id == 4 ? true : false;
  const API_URL = import.meta.env.VITE_API_URL;
  const accessToken = useSelector((state) => state.user.accessToken);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const navigate = useNavigate();
  const title = getNavbarTitle();

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  const showNoPharmacyModal = () => {
    Modal.warning({
      title: "No Pharmacy Assigned",
      content: "You are not assigned to any pharmacy. Please contact support or log out.",
      okText: "Logout",
      onOk: handleLogout,
    });
  };

  const fetchPharmacy = async () => {
    try {
      let localPharmacyList;
      const response = await axios.get(`${API_URL}users?id=${user.id}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (user.roleDetails.id == 2) {
        localPharmacyList = response.data.user.branches
          ? response.data.user.branches.map((branch) => ({
            name: branch.PharmacyDetails.name,
            id: branch.PharmacyDetails.id,
          }))
          : [];
      }

      if (user.roleDetails.id == 4) {
        localPharmacyList = response.data.user.pharmacyDetails
          ? [{
            name: response.data.user.pharmacyDetails.name,
            id: response.data.user.pharmacyDetails.id,
          }]
          : [];
      }

      if (localPharmacyList.length === 0) {
        showNoPharmacyModal();
        return;
      }

      // Set first pharmacy as default if none is selected
      if (!pharmacyDetails && localPharmacyList.length > 0) {
        dispatch(setPharmacyDetails(localPharmacyList[0]));
      }

      setPharmacyList(localPharmacyList);

    } catch (error) {
      console.error("Error fetching pharmacy details:", error);
    }
  };

  const handlePharmacyChange = (value) => {
    const selectedPharmacy = pharmacyList.find((pharmacy) => pharmacy.id === value);
    if (selectedPharmacy) {
      console.log('Dispatching pharmacy details:', selectedPharmacy);
      dispatch(setPharmacyDetails(selectedPharmacy));
    }
  };

  useEffect(() => {
    if (user.roleDetails.id == 2 || user.roleDetails.id == 4) {
      fetchPharmacy();
    }
  }, [user, accessToken]);

  return (
    <div
      className={`flex flex-col md:flex-row justify-between items-start md:items-center min-h-[90px] p-4 border-b-[#E8E8E8] border-b-[1px] ${isResponsiveMode ? 'navbar-responsive' : ''}`}
      style={{ backgroundColor: "white" }}
    >
      <div className={`flex flex-col md:flex-row items-start md:items-center gap-3 w-full md:w-[50%] ${isResponsiveMode ? 'flex-row items-center' : ''}`}>
        <div className={`flex flex-row items-center space-x-3 ${isResponsiveMode ? 'space-x-0' : ''}`}>
          <Button
            size="large"
            type="text"
            icon={isSidebarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={toggleSidebar}
            className={isResponsiveMode && isSidebarCollapsed ? "sidebar-toggle-btn" : ""}
          />
          <Button
            size="large"
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
          />
          <span className="text-[20px] md:text-[28px] font-semibold text-[#1C1C1C] flex items-center">{title}</span>
        </div>
        {
          [4].includes(user.roleDetails.id) ? (
            <p className={`text-sm md:text-base mt-2 md:mt-0 ${isResponsiveMode ? 'mt-0 ml-2' : ''}`}>Pharmacy : {pharmacyDetails ? pharmacyDetails.name : pharmacyList[0]?.name}</p>
          ) : null
        }
        {
          [2].includes(user.roleDetails.id) ? (
            <Select
              disabled={disabled}
              className={`w-full md:w-[25%] mt-2 md:mt-0 ${isResponsiveMode ? 'mt-0 ml-2 w-auto' : ''}`}
              value={pharmacyDetails?.id || (pharmacyList[0]?.id)}
              onChange={handlePharmacyChange}
            >
              {[...new Set(pharmacyList.map(pharmacy => pharmacy.name))]
                .map((name, index) => {
                  const pharmacy = pharmacyList.find(p => p.name === name);
                  return (
                    <Select.Option key={pharmacy.id} value={pharmacy.id}>
                      {name}
                    </Select.Option>
                  );
                })}
            </Select>
          ) : null
        }
      </div>

      <div className={`flex gap-2 space-x-5 mt-4 md:mt-0 ${isResponsiveMode ? 'mt-0 space-x-0' : ''}`}>
        <NavbarIconButton onClick={showModal} iconPath="/assets/images/profile-icon.svg" />
        <NotificationsTab />
        <ProfilePopup isOpen={isModalOpen} closeModal={closeModal} />
      </div>
    </div>
  );
};

export default Navbar;
